<ion-button
    *ngIf="isClickable; else unwrapped"
    (click)="onClick()"
    class="rating-star-button"
    fill="clear"
    [style.width]="size + 'px'"
    [style.height]="size + 'px'">
    <ng-content *ngTemplateOutlet="unwrapped"></ng-content>
</ion-button>

<ng-template #unwrapped>
    <div
        class="position-relative full-width full-height"
        [style.min-width]="size + 'px'"
        [style.min-height]="size + 'px'">
        <div
            class="rating-star-icon"
            [ngClass]="{ 'rating-icon-primary': display !== 'empty', 'rating-icon-grey': display === 'empty' }">
            <lib-svg-icon [iconName]="display === 'half' ? 'star-half-fill' : 'star-fill'" [size]="size" />
        </div>

        <div *ngIf="display === 'half'" class="rating-icon-grey under-star rating-star-icon">
            <lib-svg-icon iconName="star-fill" [size]="size" />
        </div>
    </div>
</ng-template>
